import React, { useState } from "react";
import "./TeamSection.css";

const TeamCard = ({ src, name, role, bio }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="team-card">
      <img src={src} alt={name} className="lazy-image loaded" decoding="async" />
      <div className="team-card-content">
        <h3>{name}</h3>
        <div className="team-role">{role}</div>
        <p className={`team-bio ${expanded ? "expanded" : ""}`}>{bio}</p>
        <button className="read-more-btn" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

const TeamSection = () => {
  return (
    <>
      <section className="section" id="team">
        <div className="container">
          <h2 className="section-title">Team</h2>
          <div className="team-grid">
            <TeamCard
              src="/MD.png"
              name="Muhammad Akmal"
              role="Managing Director"
              bio="With 25 years' progressive management experience and scholarship in marketing, Mr Muhammad Akmal is alumnus of National Defense University, Peshawar University and Virtual University of Pakistan. Besides heading a public sector music school, he is founding Managing Director of Abbott Music Studio."
            />
            <TeamCard
              src="/yasir.png"
              name="Yasir Qureshi"
              role="Technical Director"
              bio="Electronic media specialist, electronic sound designer, music composer, professional Cinematographer and photographer with more than 28 years of working experience with national and International broadcasters and news and media organizations at different positions in & outside Pakistan. Yasir Qureshi is founding member of Abbott Music Studio and is Director Technical and Collaborations."
            />
            <TeamCard
              src="/EMU.png"
              name="Syed Mohammad Imran Momina, EMU"
              role="Director Productions"
              bio="IMRAN MOMINA AKA EMU is a highly accomplished, award-winning Pakistani musician, keyboardist, composer and music producer. He is also the brains behind Fuzon, one of Pakistan’s leading rock bands. Emu’s signature style of blending Eastern classical and folk vocals with soft rock has won the group many awards and recognition all over the world. Emu has also composed and produced music albums for many leading artists. Presently he is leading the sound production department at Abbott Music Studio."
            />
          </div>
        </div>
      </section>

      {/* MD'S MESSAGE SECTION */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">MD's Message</h2>
          <div className="md-message">
            <p>
              Cognizant of the critical need for a space that fosters creativity,
              collaboration with industry and academia, and unwavering commitment
              to excellence in sound and music production, development of Abbot
              Music Studio has been undertaken with a lot of passion. Abbot Music
              Studio is a major milestone aimed at and has the potential to beacon
              artists (solo and bands), voiceover talent, producers & recordists in
              traditional and innovative Music Industry of Pakistan. The studio
              boasts an impressive array of state-of-the-art equipment, from
              precision microphones to cutting-edge digital workstations. It is an
              ideal canvas for sonic masterpieces and contemporary compositions.
              Availability of sound proof chambers and state-of-the-art mixing
              console ensures that melody reaches its full potential. The Studio
              has been affiliated with National University of Technology, Islamabad
              fora range of mid and advance level certifications and courses in
              musicology and sound production. Collaborative projects with
              academia, internships and workshops are also opportunities to be
              explored to optimum.
            </p>
            <div className="md-message-tagline">
              Join the Symphony of Excellence!
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TeamSection;
